import { render, staticRenderFns } from "./NotificationCardActions.vue?vue&type=template&id=647402ef&"
import script from "./NotificationCardActions.vue?vue&type=script&lang=js&"
export * from "./NotificationCardActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports